import { j as o } from "./index.es33.js";
import { t as p } from "./index.es106.js";
import { Icon as s } from "./index.es7.js";
import { Typography as t } from "./index.es35.js";
import { palette as c } from "./index.es36.js";
import i from "./index.es585.js";
var a = {
  copy: p("component_component_copyLabel_copyTooltip"),
  success: o.jsxs(t.Body2, {
    as: "div",
    className: i.successCopy,
    children: [o.jsx(s, {
      size: 16,
      color: c.gray1,
      icon: s.icons.system.s.utilities.tick
    }), o.jsx("span", {
      children: p("component_component_copiedLabel_copiedTooltip")
    })]
  })
};
export { a as CopyTooltip };